import { IOmniaCommand, IOmniaShell, LocaleString } from "../omnia";
import { IFieldsService } from "../types";

export class EditCmd implements IOmniaCommand {
    text: LocaleString = "Edit crop colours";
    icon: string = "fas fa-paint-roller";

    foreground = false;

    constructor(public fieldSvc: IFieldsService, public shell: IOmniaShell) {}

    canExecute(): boolean {
        return !this.shell.isReadOnly((p) => p.fields);
    }

    execute() {
        this.shell.showComponentAsDialog("omnia-fields-styles-dialog", null, {
            size: "xxlarge",
        });
    }
}
